import {TTableColumnFilterExpression} from 'components/@common/widgets/custom-table/table-column-filter/table-column-filter-types';

export const TABLE_COLUMN_FILTER_CLEAR_EVENT_KEY = 'TABLE_COLUMN_FILTER_CLEAR_EVENT';

// filters loader
export const INITIAL_FILTER_EXPR: TTableColumnFilterExpression = [{connectBy: 'OR'}, {value: '', columnName: undefined}];

export const FILTER_NOT_SELECTED = null;
